import DashboardFilters from "../../../_dashboard-filters";
import { mapState } from "vuex";
import { TechnicalStatuses } from "../../../../constants/technical_statuses";
import i18n from "../../../../plugins/i18n";

export default {
  name: "TechnicalStatusFilter",
  props: { setMainFilter: Function, selectedFilter: Object },
  components: { DashboardFilters },
  data() {
    return {
      // Filters
      options: [
        {
          filter: TechnicalStatuses.GatewayStatus,
          name: this.$t('technicalStatus.gateways'),
          icon: "msyst-icon_lorawan-orange"
        },
        {
          filter: TechnicalStatuses.CowsNotSeen,
          name: this.$t('technicalStatus.notSeen24hrs'),
          icon: "msyst-icon_lorawan-orange"
        },
        {
          filter: TechnicalStatuses.CowsWithHighPm,
          name: this.$t('technicalStatus.cowsWith24PM'),
          icon: "msyst-icon_lorawan-orange"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      summary: state => {
        return state.technicalStatuses.totals;
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_dashboard/technical-status/filter/technical-status-filter.js